import React, { Component } from 'react';
import { connect } from 'react-redux';

import CustomScrollbar from 'web/components/common/CustomScrollbar';
import Dim from 'web/components/common/modal/common/Dim';

import TermContent from 'web/routes/info/TermContent';

import { initModal, pushModal } from 'shared/actions/modal.action';

@connect(
  (state, props) => ({
    type: state.shared.modal.type,
    data: state.shared.modal.data,
  }),
  { initModal, pushModal },
)
class PolicyContainer extends Component {
  state = {
    options: {
      gender: 'woman',
      age: '10',
    },
  };

  handleChange = e => {
    const { target = {} } = e;
    const { name, value } = target;

    this.setState({
      options: {
        ...this.state.options,
        [name]: value,
      },
    });

    // console.log({ target, name, value, checked });
  };

  render() {
    const { initModal } = this.props;

    //TODO policy

    return (
      <Dim onClick={initModal}>
        <div
          style={{
            position: 'relative',
            width: '325px',
            padding: '30px 15px 100px',
            backgroundColor: '#fff',
            color: '#000',
          }}
        >
          <div className="policy">
            <div
              className="title"
              style={{
                fontSize: '20px',
                lineHeight: '2.5',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              약관 보기
            </div>
            <div
              className=""
              style={{
                height: '235px',
                overflow: 'hidden',
                overflowY: 'auto',
                padding: '10px',
                border: 'solid 1px #dcdcdc',
              }}
            >
              <CustomScrollbar right={-11} width={16} radius={2}>
                <TermContent fontSize={'10px'} />
              </CustomScrollbar>
            </div>
            <button
              type="button"
              onClick={initModal}
              style={{
                position: 'absolute',
                left: '0',
                bottom: '0',
                width: '100%',
                height: '55px',
                backgroundColor: '#dcdcdc',
                color: '#000',
                fontSize: '14px',
                textAlign: 'center',
              }}
            >
              닫기
            </button>
          </div>
        </div>
      </Dim>
    );
  }
}

export default PolicyContainer;
